import { makeStyles } from '@alpha/ui-lib/theme';

const useStyles = makeStyles(
  ({ typography }) => ({
    drawer: {
      minWidth: '605px',
      position: 'relative',
      minHeight: '100vh',
      '& .MuiDrawer-paper': {
        maxWidth: '600px',
        '& > button:first-of-type': {
          zIndex: 1,
        },
      },
    },
    container: {
      padding: '20px',
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    footer: {
      margin: '32px 0',
    },
    icon: {
      color: '#1E8777',
      width: 26,
      height: 26,
      verticalAlign: 'middle',
    },
    heading: {
      fontSize: '22px',
      fontWeight: 400,
      paddingLeft: '7px',
    },
    verticalDivider: {
      margin: '12px',
    },
  }),
  { name: 'CreateSpotDrawer' },
);

export default useStyles;
